import {IPrimaryKey} from "../interfaces/iprimary-key";

export class Cid10PrimaryKey implements IPrimaryKey<Cid10Model> {
  seq_Cid: number = 0;

  get id(): string {
    return `${this.seq_Cid}`;
  }
}

export class Cid10Model extends Cid10PrimaryKey {
  cid_10: string = "";
  descricao_Cid: string = "";
}
